import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Input, Label, Button, Alert } from 'reactstrap';
import { getErrorMessageKey } from '../../../utils/helper';
import { nextQuestion } from '../../../actions/passing';
import { saveReply } from '../../../utils/Api';
import Explanation from './_explanation';
import { isLocal, domain } from '../../../config';
// import { toHHMMSS } from '../../../utils/helper';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

const mapStateToProps = ({ user, passing, i18n: { translations } }) => ({
  permissions: user.permissions || [],
  translations,
  passing,
  // lessonTypes: [
  //   { id: 1, name: 'Poll' },
  //   { id: 2, name: 'Testing' },
  //   { id: 3, name: 'Learning' },
  // ],
  // questionTypes: [
  //   { id: 0, name: 'Poll' },
  //   { id: 1, name: 'Single' },
  //   { id: 2, name: 'Multiple' },
  //   { id: 3, name: 'Free text' },
  // ],
  errorMessage: passing.errorMessage,
  allow_chat: user.options && user.options.allow_chat,
  hide_links_on_learning: user.options && user.options.hide_links_on_learning,
  all_in_one_tab: user.options && user.options.all_in_one_tab,
  new_question_new_tab: user.options && user.options.new_question_new_tab,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      nextQuestion,
    },
    dispatch,
  );

class NextQuestion extends React.Component {
  constructor(props) {
    super(props);

    this.id = +props.match.params.id;

    this.onChange = this.onChange.bind(this);
    this.onChangeFreeText = this.onChangeFreeText.bind(this);
    this.getQuestionNumber = this.getQuestionNumber.bind(this);
    this.isLastQuestion = this.isLastQuestion.bind(this);
    this.isLastQuestionOfLastLesson = this.isLastQuestionOfLastLesson.bind(this);
    this.isLearning = this.isLearning.bind(this);
    this.isSingle = this.isSingle.bind(this);
    this.submit = this.submit.bind(this);
    this.next = this.next.bind(this);
    this.getPreview = this.getPreview.bind(this);

    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      selected: {},
      finished: false,
      trainingFinished: false,
      errorMessage: '',
      response: {
        clarification: '',
        correctAnswers: [],
      },
      free_text: '',
    };
  }

  componentDidMount() {
    this.props.nextQuestion(this.id);
  }

  onChange({ target }) {
    const { selected } = this.isSingle() ? { selected: {} } : this.state;
    const itemId = +target.getAttribute('data-item-id');
    selected[itemId] = target.checked;
    this.setState({ selected, errorMessage: '' });
  }

  onChangeFreeText({ target }) {
    this.setState({ [target.id]: target.value, errorMessage: '' });
  }

  getQuestionNumber() {
    const { questions_left, questions_count } = this.props.passing.lesson;
    return questions_count - questions_left + 1;
  }

  getPreview(item, width = 640, height = 480, full = false) {
    this.fileOutput = <span />;
    switch (item.file_type) {
      case 'image':
        this.fileOutput = full
          ? [
            <p style={{ textAlign: 'center' }}>
              <img
                src={`${item.file_link}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: height }}
              />
            </p>,
          ]
          : [
            <p className="img_preview">
              <img
                src={`${item.file_link}?w=${width}&h=${height}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: height }}
              />
            </p>,
          ];
        break;
      case 'video':
        this.fileOutput = full
          ? [
            <p style={{ textAlign: 'center' }}>
              <video width="100%" preload="metadata" controls>
                <source src={item.file_link} type="video/mp4" />
                <source src={item.file_link} type="video/avi" />
                <track kind="captions" label={item.original_name || ''} />
              </video>
            </p>,
          ]
          : [
            <p className="video_preview">
              <img
                src={`${item.file_link}?w=${width}&h=${height}` || ''}
                alt={item.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </p>,
          ];
        break;
      case 'audio':
        this.fileOutput = full ? (
          [
            <p style={{ textAlign: 'center' }}>
              <audio style={{ width: '100%' }} preload="metadata" controls>
                <source src={item.file_link} type="audio/mp3" />
                <source src={item.file_link} type="audio/aac" />
                <source src={item.file_link} type="audio/wav" />
                <source src={item.file_link} type="audio/mp4" />
                <track kind="captions" label={item.original_name || ''} />
              </audio>
            </p>,
          ]
        ) : (
          <p className="video_preview">{item.original_name || ''}</p>
        );
        break;
      default:
        this.fileOutput = (
          <p className="video_preview">{item.original_name || ''}</p>
        );
    }

    return [
      this.fileOutput,
      '',
      // <p>
      //   {(item.size &&
      //     (item.file_type === 'image' || item.file_type === 'video' || item.type === 'audio')) &&
      //       `${Math.round((item.size * 100) / 1024 / 1024) / 100} Mb`
      //   }
      //   {(item.duration &&
      //     (item.file_type === 'video' || item.file_type === 'audio')) &&
      //       ` / ${toHHMMSS(item.duration)}`
      //   }
      // </p>,
    ];
  }

  // we need to redirect after answer on last question
  isLastQuestion() {
    return (
      this.getQuestionNumber() === this.props.passing.lesson.questions_count
    );
  }

  // we need to redirect after answer on last question of last lesson
  isLastQuestionOfLastLesson() {
    return this.props.passing === 1; // TODO: some parameter from API
  }

  // we need to show correct answers and clarification after answer if type is "Learning"
  isLearning() {
    return this.props.passing.lesson.type === 'Learning';
  }

  // here we allow just one answer
  isSingle() {
    return (
      this.props.passing.lesson.question.type === 'Single' ||
      this.props.passing.lesson.question.type === 'Poll' ||
      this.props.passing.lesson.question.type === 'Free text'
    );
  }

  submit() {
    const { selected, free_text } = this.state;
    const { intl, passing, translations } = this.props;
    const selectedAnswers = Object.keys(selected).reduce((res, key) => {
      if (selected[key]) res.push(+key);
      return res;
    }, []);
    if (!selectedAnswers.length && !free_text) {
      this.setState({
        errorMessage: intl.formatMessage({ id: 'passing_nothingSelected' }),
      });
      return;
    }
    saveReply(this.id, {
      question_id: passing.lesson.question.id,
      free_text,
      answers: selectedAnswers,
    }).then(({ error, clarification, answers }) => {
      if (error) {
        const message = getErrorMessageKey(translations, error.code) || error.msg;
        this.setState({ errorMessage: message || 'saving reply error' });
        return;
      }
      if (answers) {
        this.setState({ response: { clarification, correctAnswers: answers } });
        return;
      }

      this.next();
    });
  }

  next(text) {
    const { intl: { formatMessage }, all_in_one_tab, new_question_new_tab } = this.props;
    if (text === formatMessage({ id: 'overall_input_next' }) && new_question_new_tab && !all_in_one_tab) {
      window.open(document.location.href, '_blank');
      return;
    }

    if (this.isLastQuestion()) {
      this.setState({ finished: true });
    } else if (this.isLastQuestionOfLastLesson()) {
      this.setState({ trainingFinished: true });
    } else {
      this.setState(this.getInitialState());
      this.props.nextQuestion(this.id);
    }
  }

  render() {
    const {
      selected,
      response,
      finished,
      trainingFinished,
      errorMessage,
    } = this.state;
    const { intl, permissions, passing, allow_chat, hide_links_on_learning, all_in_one_tab } = this.props;
    if (!permissions.includes('LESSON_QUESTION_DETAILS')) {
      return null;
    }

    const { clarification, correctAnswers } = response;
    const { question, questions_count, training_id } = passing.lesson;

    if (finished) {
      return (
        <Redirect
          to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/results`}
        />
      );
    }

    if (trainingFinished) {
      return <Redirect to={`/trainings/mytrainings/${training_id}/results`} />;
    }

    if (!question) {
      return null;
    }

    let buttonLabel = intl.formatMessage({ id: 'overall_input_next' });
    if (this.isLearning()) {
      if (!correctAnswers.length) {
        buttonLabel = intl.formatMessage({ id: 'overall_input_submit' });
      } else if (this.isLastQuestion()) {
        buttonLabel = intl.formatMessage({ id: 'overall_input_finish' });
      }
    }

    return (
      <div>
        {!hide_links_on_learning &&
          <div className="category_block">
            <ul>
              {allow_chat && (
                <li className="category">
                  <Link to="/trainings/chats" target={all_in_one_tab ? "_self" : "_blank"}>
                    <i className="icon_c icon_c_bg icon_chats" />
                    <FormattedMessage id="routes_chats" />
                  </Link>
                </li>
              )}
              <li className="category">
                <a href={`${path}/reports/users`} target={all_in_one_tab ? "_self" : "_blank"} rel="noreferrer" >
                  <i className="icon_c icon_c_bg icon_reports" />
                  <FormattedMessage id="routes_reports" />
                </a>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/notes`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_notes" />
                  <FormattedMessage id="routes_notes" />
                </Link>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/notes`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_images" />
                  <FormattedMessage id="routes_pictures" />
                </Link>
              </li>
              <li className="category">
                <Link to="/trainings/certificates" target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_cert" />
                  <FormattedMessage id="routes_certificates" />
                </Link>
              </li>
            </ul>
          </div>
        }
        <div className="main_content">
          <section>
            <div className="header-section">
              <div className="holder_number">
                <div className="question_number">
                  <span>{this.getQuestionNumber()}</span> /{' '}
                  <span>{questions_count}</span>
                </div>
              </div>
              <div
                className="question"
                dangerouslySetInnerHTML={{ __html: question.description }}
              />
              <div className="button-info info">
                <Explanation
                  text={clarification ? clarification || '' : question.explanation || ''}
                  type={clarification ? 'clarification' : 'explanation'}
                  correctAnswersLength={correctAnswers.length}
                />
                {correctAnswers.length && passing.lesson.question.explanation_enabled
                  ? (
                    <div className="question-explanation">
                      <div className="question-explanation__header">
                        Explanation
                      </div>
                      <div className="question-explanation__text">
                        <p><span dangerouslySetInnerHTML={{ __html: passing.lesson.question.clarification }}></span></p>
                      </div>
                    </div>
                  )
                  : ''}
              </div>
            </div>
            <div className="content">
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  // alignItem: 'stretch',
                }}
                className="mob-row-reverse"
              >
                <div
                  className={passing.lesson.question.type === 'Free text'
                    ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-right col-lg-6'
                    : 'col-md-6 col-sm-6 col-xs-12 pull-right'}
                  style={
                    passing.lesson.question.type === 'Free text'
                      ? {
                        display: 'flex',
                        // alignItem: 'stretch',
                      }
                      : {}
                  }
                >
                  {passing.lesson.question.type !== 'Free text' ? (

                    question.answers.map(({ id, title }) => (
                      <div
                        key={id}
                        className={`checkbox_block 
                        ${this.isSingle() ? 'radio' : 'checkbox'}
                        ${correctAnswers.length &&
                          ((selected[id] && correctAnswers.includes(id)) ||
                            (!selected[id] && !correctAnswers.includes(id))
                            ? ' right_answer'
                            : ' wrong_answer')
                          }`}
                      >
                        <Input
                          data-item-id={id}
                          id={`answer_${id}`}
                          name="answer"
                          type={this.isSingle() ? 'radio' : 'checkbox'}
                          onChange={this.onChange}
                          disabled={correctAnswers.length}
                          className={`${correctAnswers.length &&
                            ((selected[id] && correctAnswers.includes(id)) ||
                              (!selected[id] && !correctAnswers.includes(id))
                              ? ' right_answer'
                              : ' wrong_answer')
                            }`}
                        />
                        <Label
                          className="checkbox_label"
                          htmlFor={`answer_${id}`}
                          style={{
                            borderColor: `${correctAnswers.length &&
                              ((selected[id] && correctAnswers.includes(id)) ||
                                (!selected[id] && !correctAnswers.includes(id))
                                ? 'green'
                                : 'red')
                              }`,
                          }}
                        />
                        <Label
                          htmlFor={`answer_${id}`}
                          style={{
                            fontWeight: `${correctAnswers.length &&
                              ((selected[id] && correctAnswers.includes(id)) ||
                                (!selected[id] && !correctAnswers.includes(id))
                                ? '900'
                                : 'normal')
                              }`,
                          }}><span dangerouslySetInnerHTML={{ __html: title }}></span></Label>
                      </div>
                    ))
                  ) : (
                    <Input
                      id="free_text"
                      name="free_text"
                      type="textarea"
                      maxLength="2048"
                      onChange={this.onChangeFreeText}
                      value={this.state.free_text}
                    />
                  )}
                  {correctAnswers.length
                    ? (
                      <div className="desktop-massage">
                        <span className="desktop-massage__red">
                          <FormattedMessage id="questions_mark_not_correct" />
                        </span>
                        <br />
                        <span className="desktop-massage__green">
                          <FormattedMessage id="questions_mark_correct" />
                        </span>
                      </div>
                    )
                    : ''}
                </div>
                <div
                  // className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-right tc"
                  className="col-md-6 col-sm-6 col-xs-12"
                >
                  <p className="short_title title">{question.title}</p>
                  <p>{this.getPreview(question, 320, 240, true)}</p>
                  {/* {question.file_link && (
                    <a href={question.file_link} rel="noopener noreferrer" target={all_in_one_tab ? "_self" : "_blank"} onClick={e => e.stopPropagation()}>
                      <FormattedMessage id="overall_input_download" />
                    </a>)
                  } */}
                  <div className="clear10" />
                </div>
              </div>
              <div className="clear20" />
              {errorMessage && (
                <Alert color="danger">
                  <FormattedMessage id={errorMessage} />
                </Alert>
              )}
              <div className="col-lg-12 tc">
                {/* {clarification && (
                  <div className="answer_style">
                    <div
                      placement="bottom"
                      target="PopoverExplanation"
                      className="answer_popover"
                    >
                      <span>{clarification}</span>
                    </div>
                  </div>
                )} */}
                <Button
                  className="btn btn-custom btn-lg next_btn f20"
                  onClick={() => (correctAnswers.length
                    ? this.next(buttonLabel)
                    : this.submit())
                  }
                >
                  {buttonLabel}
                </Button>
                {correctAnswers.length
                  ? (
                    <div className="mobile-massage">
                      <span className="mobile-massage__red">
                        <FormattedMessage id="questions_mark_not_correct" />
                      </span>
                      <br />
                      <span className="mobile-massage__green">
                        <FormattedMessage id="questions_mark_correct" />
                      </span>
                    </div>
                  )
                  : ''}
              </div>
              <div className="clear10" />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

NextQuestion.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  passing: PropTypes.objectOf(PropTypes.any),
  match: PropTypes.objectOf(PropTypes.any),
  nextQuestion: PropTypes.func.isRequired,
  allow_chat: PropTypes.bool,
  all_in_one_tab: PropTypes.bool,
  new_question_new_tab: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NextQuestion));



// WEBPACK FOOTER //
// ./src/views/_Lessons/Passing/index.js